import clsx from 'clsx';
import React from 'react';
import UserIcon from '../../assets/icons/user-icon.svg?react';
import Input from '../Input';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { FormikProps } from 'formik';

interface DeleteDepartmentModalProps {
  otherClasses?: string;
  currentDepartment: any;
  formHandler: FormikProps<{ name: string }>;
  handleClose: () => void;
}

const DeleteDepartmentModal: React.FC<DeleteDepartmentModalProps> = ({
  otherClasses,
  formHandler,
  handleClose,
  currentDepartment,
}) => {
  const DeleteDepartmentModalClasses = clsx(otherClasses);

  return (
    <div
      className={DeleteDepartmentModalClasses}
      data-testid="delete-user-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <UserIcon className="[&>path]:fill-brand-posh-pink h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink">Are you sure?</h4>
        <p className="font-inter-variable text-neutral-tones-text -tracking-text-area text-base leading-5 font-normal lg:text-lg">
          To continue deletion process, type the word{' '}
          <strong>
            “{currentDepartment?.name.trim().replace(/\s+/g, ' ')}”
          </strong>{' '}
          exactly into the text field below.
        </p>
        <p className="font-inter-variable text-neutral-tones-text -tracking-text-area mt-2 text-base leading-5 font-normal lg:text-lg">
          Please note that this action is irreversible.
        </p>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mt-2.5 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label={`Type "${currentDepartment?.name.trim().replace(/\s+/g, ' ')}"`}
            errorMessage={
              formHandler?.touched.name && formHandler?.errors.name
                ? formHandler?.errors.name
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.name}
            type="text"
            placeholder="Type department name"
            onChange={formHandler?.handleChange}
            name="name"
            otherClasses={{ container: 'w-full' }}
          />
        </div>
        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={useButtonSizeSmall()}
            onClick={() => handleClose()}
            otherClasses="border-transparent text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            loading={formHandler?.isSubmitting}
            disable={
              formHandler?.values.name.trim().replace(/\s+/g, ' ') !==
                currentDepartment?.name.trim().replace(/\s+/g, ' ') ||
              formHandler?.isSubmitting
            }
            size={useButtonSizeSmall()}
            otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink"
          >
            Delete Department
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DeleteDepartmentModal;
